"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlaceDetail = exports.autoComplete = void 0;
var autoComplete = function (keyword) {
    if (!typeof google === undefined)
        return null;
    return new Promise(function (resolve) {
        var autocompleteService = new google.maps.places.AutocompleteService();
        var request = {
            input: keyword,
            componentRestrictions: {
                country: 'hk',
            },
        };
        autocompleteService.getPlacePredictions(request, function (results, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                var places = results.map(function (it) {
                    return {
                        name: it.description,
                        placeId: it.place_id,
                        address: it.structured_formatting.main_text,
                        district: it.structured_formatting.secondary_text,
                    };
                });
                resolve(places);
            }
            else {
                resolve([]);
            }
        });
    });
};
exports.autoComplete = autoComplete;
var getPlaceDetail = function (id) {
    return new Promise(function (resolve) {
        var placeService = new google.maps.places.PlacesService(document.createElement('div'));
        placeService.getDetails({
            placeId: id,
            fields: ['geometry.location'],
        }, function (result, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                var detail = {
                    position: {
                        lat: result.geometry.location.lat(),
                        lng: result.geometry.location.lng(),
                    },
                };
                resolve(detail);
            }
            else {
                resolve([]);
            }
        });
    });
};
exports.getPlaceDetail = getPlaceDetail;
